<template>
  <div class="">
    <div class="img"> </div>
  </div>
</template>

<script>

export default {
  name: 'Index',
}

</script>

<style lang="scss" scoped>
#container {
  width: calc(100vh);
  height: calc(100vh);

}

.inner_center{
  border: 1px solid #000;
}

.img{
  @include BgImage(678px,661px,'3d/model/3d-model2.png')
}
</style>
